export const ENGLISH_LANGUAGE = {
  flag: "🇬🇧",
  label: "english",
  code: "en",
  header: {
    aboutMe: "About me",
    skills: "Skills",
    experiences: "Experiences",
    projects: "Projects",
    contact: "Contact",
    review: "Review",
    download: "Download my CV",
  },

  contact: {
    thanks: "Thanks for your visit !",
    msg: ["Give your feedback", "here."],
    joinMe: "Join me on",
  },

  footer: {
    copyright: `Copyright© 2017-${new Date().getFullYear()} Brillant. All rights reserved.`,
    language: "Language",
  },
};
